import FluidContainer from './FluidContainer';

export default FluidContainer;
